import { getBrowserLanguage } from 'pages/views/payments/helpers';
import Intercom from 'root/apps/intercom/Intercom';

export enum SurveyType {
  OFFER_DISMISSAL = 'offer_dismissal',
}

const ENGLISH_OFFER_DISMISSAL_SURVEY_ID = 38420815;
const FRENCH_OFFER_DISMISSAL_SURVEY_ID = 38421224;

const surveyMap = new Map<string, Map<SurveyType, number>>([
  [
    'en',
    new Map<SurveyType, number>([[SurveyType.OFFER_DISMISSAL, ENGLISH_OFFER_DISMISSAL_SURVEY_ID]]),
  ],
  [
    'fr',
    new Map<SurveyType, number>([[SurveyType.OFFER_DISMISSAL, FRENCH_OFFER_DISMISSAL_SURVEY_ID]]),
  ],
]);

export const getSurveyId = (survey: SurveyType) => {
  const language = getBrowserLanguage();
  return surveyMap.get(language)?.get(survey);
};

export const showSurvey = (survey: SurveyType) => {
  const surveyId = getSurveyId(survey);
  if (!surveyId) {
    return;
  }

  Intercom.showSurvey(surveyId);
};
